.<template>
  <base-crud
    crudName="Estações de Trabalho"
    newText="Nova Estação de Trabalho"
    :table="table"
    :columns="columns"
    :options="options"
    :endPoint="endPoint"
    :enableAdd="true"
    :enableEdit="true"
    :enableDelete="true"
    :enableView="true"
    :dataForm="dataForm"
    :extra="extra"
    @configuration=configuration
  />
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data: function() {
    return {
      extra: [
        {
          id: 1,
          label: '',
          class: 'btn btn-crud edit',
          icon: 'fas fa-cog',
          title: 'Configuração',
          name: 'configuration',
        }
        
      ],
      table: "workstations",
      columns: [
        "id",
        "photo",
        "qrcodeid",
        "title",
        "tag",
        "company_id",
        "floor",
        "capacity",
        "actions"
      ],
      tableData: [
        "id",
        "photo",
        "qrcodeid",
        "title",
        "tag",
        "company_id",
        "floor",
        "number_room",
        "capacity"
      ],
      options: {
        filterable: [
          "id",
          "title",
          "tag",
          "floor",
          "company_id",          
          "capacity"
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "Foto",
          qrcodeid: "QRCode",
          title: "Titulo",
          tag: "Tag",
          company_id: "Empresa",
          floor: "Andar",          
          capacity: "Qtd de Posições",
          actions: "Ações"
        },
        templates: {
          company_id: function(h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },
          qrcodeid: function(h,row,index){
            return 'workstation-' + row.qrcodeid
          }
        },
        requestFunction: function(data) {
          let requestData = {};
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];
          return this.$http.get(this.url + "?" + query, requestData).catch(
            function(e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        }
      },
      endPoint: "workstations/",
      dataForm: {},      
    };
  },
  components: {
    BaseCrud
  },
  methods: {
    configuration(data){      
      this.$router.push({ path: "/workstations/configuration/" + data.row.id });
    },
    query: function(query) {
      let columns = {
        id: "id",
        photo: "photo",
        title: "title",
        tag: "tag",
        company_id: "company[company_name]",
        floor: "floor",
        number_room: "number_room",
        capacity: "capacity"
      };
      let filters = "";
      $.each(query, function(index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    }
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Workstations/Crud.vue